var ApiServices = /** @class */ (function () {
    function ApiServices() {
    }
    ApiServices.register = function (key, service) {
        var serviceInstance = ApiServices._map[key];
        if (serviceInstance) {
            console.warn("".concat(key, " service already exist"));
            return serviceInstance;
        }
        ApiServices._map[key] = service;
        return service;
    };
    ApiServices.get = function (key) {
        var service = ApiServices._map[key];
        if (service) {
            return service;
        }
        console.error("not found ".concat(key, " service"));
        // throw new Error(`not found ${key} service`);
    };
    ApiServices._map = {};
    return ApiServices;
}());

export { ApiServices };
